export default __webpack_public_path__ + "static/media/Died.b11b9243.svg";